/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["a.btn-1[_ngcontent-%COMP%]{display:inline-block;padding:12px;height:auto;border:var(--ion-color-primary) 1px solid;border-radius:50px;text-decoration:none}.img-wrapper[_ngcontent-%COMP%]{position:relative}.img-wrapper[_ngcontent-%COMP%]   .remove-btn[_ngcontent-%COMP%]{position:absolute;top:16px;right:16px}"];
export { styles as styles };
